import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
// import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';


// Pages
import Home from './app/Home';
import GetStarted from './app/GetStarted';
import OrderForm from './app/OrderForm';
import OrderSuccess from './app/OrderSuccess';
import ContactForm from './app/ContactForm';
import MessageSuccess from './app/MessageSuccess';
import Login from './app/auth/Login';
import Register from './app/auth/Register';
import UnderReview from './app/auth/UnderReview';
import Approved from './app/auth/Approved';
import Dashboard from './app/dashboard/Dashboard';
import ErrorPage from './app/ErrorPage';
import OrderDetails from './app/OrderDetails';

function App() {
  console.log('App component rendering');
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen flex flex-col bg-white">
          <Navbar />
          <main className="">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/get-started" element={<GetStarted />} />
              <Route path="/order" element={<OrderForm />} />
              <Route path="/order/success" element={<OrderSuccess />} />
              <Route path="/contact" element={<ContactForm />} />
              <Route path="/contact/success" element={<MessageSuccess />} />
              <Route path="/auth/login" element={<Login />} />
              <Route path="/auth/register" element={<Register />} />
              <Route path="/auth/under-review" element={<UnderReview />} />
              <Route path="/auth/approved" element={<Approved />} />
              <Route path="/order/details" element={<OrderDetails/>} />


              <Route
                path="/dashboard"
                element={ 
                    <Dashboard/> 
                }
              />
              
              {/**login/reg dont't have an account link path */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              <Route path="*" element={<ErrorPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;

